module.exports = __webpack_public_path__ + "img/R.088c429f.webp";